import { LFlex } from "@components";
import { LBtn } from "../../../../../../common/components/LBtn";

export const ClinicianConfirmation = ({ locationName, closeModal }: ClinicianConfirmationProps): JSX.Element => {
    return (
        <LFlex justifyCenter alignCenter>
            <div className="content has-text-centered mb-0">
                <p>
                    Please make sure this assignment is in line with your organization’s rules, regulations and
                    procedures. The clinician role has access to sensitive clinical information for this location{" "}
                    <strong>{`(${locationName})`}</strong> which will include:
                </p>
                <div className="is-flex is-flex-direction-column">
                    <strong>• Examinee’s full name</strong>
                    <strong>• Gender</strong>
                    <strong>• Birth date</strong>
                    <strong>• Level of education</strong>
                    <strong>• Assessment results</strong>
                </div>
            </div>
            <div className="pt-2">
                <div className="divider" />
                <LFlex alignCenter className="is-justify-content-space-between" row>
                    <LBtn variation="outline" onClick={() => closeModal()}>
                        Cancel
                    </LBtn>
                    <LBtn onClick={() => closeModal(true)}>Continue</LBtn>
                </LFlex>
            </div>
        </LFlex>
    );
};

interface ClinicianConfirmationProps {
    locationName: string;
    closeModal: (action?: boolean) => void;
}
